import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { Opportunity, OpportunityStage } from '@jms/model';
import { BadgeComponent } from '@workbuddy/ui/components/badge';
import { TagDeriverStyle } from '@workbuddy/ui/v2/surface.engine';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { opportunityStageTag } from '../opportunity.stage.colour';

@Component({
  selector: 'opportunity-stage-cell-renderer',
  standalone: true,
  imports: [BadgeComponent],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: flex; align-items: center; min-width: 0; height: 100%; overflow: hidden;' },
  template: `@if ($tag(); as tag) { <w-tag [label]="tag.label" mode="squared" size="small" [color]="tag.color" [backgroundColor]="tag.backgroundColor" [borderColor]="tag.borderColor" /> }`,
})
export class OpportunityStageCellRendererComponent implements ICellRendererAngularComp {

  protected readonly $tag = signal<TagDeriverStyle | null>(null);

  public agInit(params: ICellRendererParams<Opportunity, OpportunityStage>): void {

    this.read(params);
  }

  public refresh(params: ICellRendererParams<Opportunity, OpportunityStage>): boolean {

    this.read(params);
    return true;
  }

  private read(params: ICellRendererParams<Opportunity, OpportunityStage>): void {

    this.$tag.set(opportunityStageTag(params.value, params.data));
  }
}
